var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMobile)?_c('div',{ref:"goto",staticClass:"goto"},[(_vm.visible)?_c('div',[_vm._t("default")],2):_vm._e()]):_c('el-collapse-transition',[(_vm.visible)?_c('div',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }